import { useState } from 'react';
import { AnnotationProps } from '../../components/annotation';

export type AnnotationState = {
  current: AnnotationProps | null;
  mode: number;
};

const modes = ['translate', 'rotate'] as const;

export function useAnnotations() {
  const [annotationState, setAnnotationsState] = useState<AnnotationState>({
    current: null,
    mode: 0,
  });

  const [annotations, setAnnotations] = useState<AnnotationProps[]>([
    {
      name: 'annotatate_' + 0,
      text: '1',
      description: `Bored gods flood mortal apartments for laughs. Bubbles, confetti chaos ensues. Celestial janitors send a warning. Gods scramble to clean up the divine mess—lesson learned!`,
      image: '/assets/incident/1.jpg',
      position: [0, 0.417, -7.289],
      snapshot: {
        target: [-0.28, 0.45, -7.52],
        position: [1.75, 0.39, -6.21],
      },
    },
    {
      name: 'annotatate_' + 1,
      text: '2',
      description: `In the celestial realm, the gods grew mischievous, causing blocked drains in mortal homes. Poseidon's watery antics and Vulcan's fiery mischief led to chaos. Mortals, baffled by sudden floods, became unwitting participants in the gods' prank. As celestial janitors sent warnings, the divine duo hurriedly unclogged the drains, realizing that even gods can face a backed-up situation!`,
      image: '/assets/incident/2.jpg',
      position: [1.67, 0.24, -2.1],
      snapshot: {
        target: [1.67, 0.24, -2.1],
        position: [4.1, 0.85, -2.38],
      },
    },
  ]);

  /*   const updateAnnotationPosition = useCallback(
    (position: AnnotationProps['position']) => {
      console.log(position);
    },
    [],
  ); */

  const setCurrentAnnotation = (annotation: AnnotationProps | null) => {
    setAnnotationsState(state => ({
      ...state,
      current: annotation,
    }));
  };

  const setAnnotationMode = () => {
    setAnnotationsState(state => ({
      ...state,
      mode: (state.mode + 1) % modes.length,
    }));
  };

  return {
    annotationState,
    setCurrentAnnotation,
    setAnnotationMode,
    annotations,
  };
}
